module.exports = "/assets/data/ed94facc44f3fc7881b2645de3f9321b-CM13.data.json";